import { AvatarsEndpoints } from '../../endpoint';
import { mapAvatarCategories } from '../../mappers/api2_0';
import { Models } from '../../';

export const getAvatarCategories: () => Promise<Models.AvatarCategories[]> = () => {
  return AvatarsEndpoints.getAvatarCategories().then(response => {
    return response.resources.map(mapAvatarCategories);
  });
};
